import { styled } from '@mui/material';

export const PageW = styled('div')`
  @media (max-width: 1280px) and (min-width: 1024px) {
    max-width: calc(100% - 38px);
  }
  @media (max-width: 1023px) {
    padding: 0px 16px 96px 16px;
  }
`;

export const TableW = styled('div')`
  padding-left: 38px;
  padding-top: 56px;
  @media (max-width: 1023px) {
    padding-left: 0px;
  }
`;
